import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { DiffEntryTitle } from '../diffIndicators/DiffEntryTitle'
import { buildTextDiff } from './diffModel'
import { DiffView } from './DiffView'

type Props = {
  title: string
  compare: Optional<string>
  current: Optional<string>
}

/**
 * A titled diff between two pieces of prose, such as a field's documentation.
 * It renders nothing at all when the two sides read the same, because an
 * unchanged row is noise in a list of what changed.
 *
 * Prose is compared exactly as it was written. Unlike an expression, there is no
 * one right way to lay it out, so there is nothing to normalise first: a line
 * broken differently is a change its author made and meant.
 */
export const TextDiff = ({ title, compare, current }: Props) => {
  const diff = useMemo(
    () => buildTextDiff({ compare, current }),
    [compare, current],
  )

  if (!diff.isChanged) {
    return null
  }

  return (
    <div>
      <DiffEntryTitle title={title} />
      <DiffView fileDiff={diff.fileDiff} />
    </div>
  )
}
